module.exports = __webpack_public_path__ + "media/images/icons/SVG/045-d99bbed9e477bad79cb6a5105acf8249.svg";